export default [
	{
		path: '/manage/shopRecharge',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '充值额度申请',
			authLogin: true,
		},
	},
]
